import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StepService {
  private currentStepSubject = new BehaviorSubject<number>(0); 
  currentStep$ = this.currentStepSubject.asObservable();

  private insuredSubject = new BehaviorSubject<boolean>(true); 
  insured$ = this.insuredSubject.asObservable();

  setCurrentStep(step: number): void {
    this.currentStepSubject.next(step);
  }

  setInsuredStatus(insured: boolean): void {
    this.insuredSubject.next(insured);
  }

  getCurrentStep(): number {
    return this.currentStepSubject.getValue();
  }

  getInsuredStatus(): boolean {
    return this.insuredSubject.getValue();
  }
}